/**
 * Main site view pane
 */

import React from "react";
import { connect } from "react-redux";

import Loading from "components/Loading";

// import { getRouterParams } from "services/redux/selectors/app/";

import { getEnterpriseFromRoute } from "services/redux/selectors/enterprises";
import { getGroupFromRoute } from "services/redux/selectors/groups";
import { getPathRootFromRoute } from "services/redux/selectors/app/";

import { withT } from "services/translation/";

import { Row, Nav, Tab, Col, Button } from "react-bootstrap";

import ErrorBoundary from "components/Layout/ErrorBoundary";

import Icon from "components/Icons/Icon";

import { changeGroupTimeframe } from "services/redux/actions/";
import { changeSingleSitesTimeframe } from "services/redux/actions/singleSites";

import { SelectTimeframe } from "components/Common/Timeframe/SelectTimeframe";

import { Bundles, Details, Keyholders, Comments } from "./Tabs/";
import ManageNotifications from "./Notifications/";
import ManageIntegrations from "./Integrations/";
import LatestAlarm from "./LatestAlarm";
import OpenClose from "./OpenClose/";
import VoiceCalls from "./VoiceCalls/";
import UserManagement from "./UserManagement";
import Schedules from "./Schedules/";
import SiteNotes from "./SiteNotes";

import CameraList from "components/Common/Cameras/CameraList/";
import Modes from "./Modes/";

import { Tooltip } from "components/Common/Tooltip/";

import find from "lodash/find";

const TabOptions = [
  {
    key: "bundles",
    col: 3,
    // col: 3,
    Component: Bundles,
  },
  // {
  //   key: "apps",
  //   col: 3,
  //   Component: Apps
  // },
  {
    key: "details",
    col: 3,
    // col: 3,
    Component: Details,
  },
  {
    key: "keyholders",
    col: 3,
    // col: 3,
    Component: Keyholders,
  },
  {
    key: "comments",
    col: 3,
    // col: 3,
    Component: Comments,
  },
];

class SiteOverview extends React.Component {
  constructor() {
    super();
    let view = "overview";

    // If on initialisation, connectTether session item exists,
    // a tether integration has just been set up so we want to show
    // that it's set up
    if (sessionStorage.getItem("tetherConnect") !== null) {
      view = "integrations";
    }

    this.state = {
      key: "bundles",
      view,
      newSiteLoading: false,
      newSiteIntegrationsLoading: false,
      groupAccess: null,
    };
  }

  onSelectBundle = (bundle_id) => {
    const { changePage, onSelectBundle } = this.props;
    // Change page on bundle select
    if (bundle_id) {
      changePage(bundle_id ? 1 : 0);
    }
    onSelectBundle(bundle_id);
  };

  componentDidMount() {
    const { enterprise, group, userAccess } = this.props;

    let groupId = (group && group.id) || (enterprise && enterprise.root_group_id);
    if (groupId === "root" || !groupId) {
      groupId = enterprise && enterprise.root_group_id;
    }

    const groupAccess = userAccess.groups ? find(userAccess.groups, ['id', groupId]) : null;
    this.setState({
      groupAccess: groupAccess
    })
  }

  componentDidUpdate(prevProps, prevState) {
    const { enterprise, site, group, userAccess } = this.props;

    // show sites schedule footer if relevant
    if (this.state.view !== prevState.view && this.state.view !== "schedules" && this.state.view !== "sitenotes") {
      this.props.setShowFooter(false);
    }

    // if we are opening the side pane and it's been passed a particular view via the props to open on, then set it to that view
    if (this.props.showSidePane && !prevProps.showSidePane) {
      if (this.props.openOnView) {
        this.setState({
          view: this.props.openOnView,
        });
      }
    }

    // if the incoming site is different to the previous one, and it's still loading, set newSiteLoading to true
    if (site.id !== prevProps.site.id && site.loading) {
      this.setState({
        newSiteLoading: true,
      })
    }

    // if the newSiteLoading is set to true but the site is no longer loading, set newSiteLoading to false
    if (this.state.newSiteLoading && !site.loading) {
      this.setState({
        newSiteLoading: false,
      })
    }

    // if the incoming site for the integrations call is different to the previous one, and it's still loading, set newSiteIntegrationsLoading to true.
    // the site_id sometimes come through as a string and sometimes as an int (and null initially), so cast to string before comparing
    if (String(site.integrations.site_id) !== String(prevProps.site.integrations.site_id) && site.integrations.loading) {
      this.setState({
        newSiteIntegrationsLoading: true,
      })
    }

    // if the newSiteIntegrationsLoading is set to true but the integrations are no longer loading, set newSiteIntegrationsLoading to false
    if (this.state.newSiteIntegrationsLoading && !site.integrations.loading) {
      this.setState({
        newSiteIntegrationsLoading: false,
      })
    }

    if (group.id !== prevProps.group.id) {
      let groupId = (group && group.id) || (enterprise && enterprise.root_group_id);
      if (groupId === "root" || !groupId) {
        groupId = enterprise && enterprise.root_group_id;
      }

      const groupAccess = userAccess.groups ? find(userAccess.groups, ['id', groupId]) : null;
      this.setState({
        groupAccess: groupAccess
      })
    }
  }

  render() {
    const {origin, t, site, changePage, bundle_id, dispatch, enterprise, group, userAccess, user, pathRoot, setShowFooter, setFooterComponent } = this.props;

    const { view, newSiteLoading, newSiteIntegrationsLoading, groupAccess } = this.state;

    const { loading } = site;

    if (loading === null) return <Loading className="py-4" center />;

    // No alarm bundles means initial load
    if ((loading === true && site.alarmBundles.length === 0) || newSiteLoading) {
      return <Loading className="py-4" center />;
    }

    if (!site) return null;

    if (view === "notifications") {
      return (
        <ManageNotifications
          origin={origin}
          site={site}
          onBackToOverview={() => {
            // Return to overview view
            this.setState({
              view: "overview",
            });
          }}
        />
      );
    } else if (view === "integrations") {
      return (
        <ManageIntegrations
          site={site}
          onBackToOverview={() => {
            // Return to overview view
            this.setState({
              view: "overview",
            });
          }}
        />
      );
    } else if (view === "openclose") {
      return (
        <OpenClose
          site={site}
          onBackToOverview={() => {
            // Return to overview view
            this.setState({
              view: "overview",
            });
          }}
          t={t}
        />
      )
    } else if (view === "modes") {
      return (
        <Modes
          origin={origin}
          site={site}
          showSidePane={this.props.showSidePane}
          openOnTab={this.props.openOnTab}
          onBackToOverview={() => {
            this.setState({
              view: "overview",
            });
          }}
        />
      )
    } else if (view === "schedules") {
      return (
        <Schedules
          origin={origin}
          site={{
            ...site,
            sudo_site_id: site.sudo_site_id || (site.sudo_site && site.sudo_site.id),
          }}
          setShowFooter={setShowFooter}
          onBackToOverview={() => {
            // Return to overview view
            this.setState({
              view: "overview",
            });
          }}
        />
      )
    } else if (view === "phone") {
      return (
        <VoiceCalls
          site={site}
          onBackToOverview={() => {
            this.setState({
              view: "overview",
            });
          }}
        />
      );
    } else if (view === "usermanagement") {
      return (
        <UserManagement
          site={site}
          group={group}
          sudoSiteId={site.sudo_site_id}
          siteName={site.name}
          onBackToOverview={() => {
            this.setState({
              view: "overview",
            });
          }}
        />
      );
    } else if (view === "sitenotes") {
      return (
        <SiteNotes
          site={site}
          setShowFooter={setShowFooter}
          setFooterComponent={setFooterComponent}
          onBackToOverview={() => {
            this.setState({
              view: "overview",
            });
          }}
        />
      );
    }

    const Tabs = (
      <Tab.Container
        activeKey={this.state.key}
        onSelect={(key) => this.setState({ key })}
      >
        <Nav variant="pills" className="row">
          {TabOptions.map(({ key, col }, index) => (
            <Nav.Item className={"col-" + col} key={index}>
              <Nav.Link eventKey={key} className="text-center">
                {t("tabs." + key)}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>

        <Row>
          <Col sm={12}>
            <Tab.Content>
              {TabOptions.map(({ key, Component }, index) => {
                const active = this.state.key === key;
                return active ? (
                  <Tab.Pane key={index} eventKey={key} className="pt-3">
                    <ErrorBoundary message="Error: couldn't load site data">
                      <Component
                        origin={origin}
                        bundle_id={bundle_id}
                        site={site}
                        changePage={changePage}
                        onSelectBundle={this.onSelectBundle}
                        viewAs="cards"
                      />
                    </ErrorBoundary>
                  </Tab.Pane>
                ) : null;
              })}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    );

    let showVoiceCallsLink = false;
    if ((origin !== "SingleSite") && enterprise && (enterprise.id !== -1) && (enterprise.voice_calls) && (userAccess.loading === false) && userAccess && group) {
      if ((group.id === "root") || (group.id === enterprise.root_group_id)) {
        if (find(userAccess.enterprise.features, ['id', 11])) { // id=11 for Voice Calls
          showVoiceCallsLink = true;
        }
      } else {
        const groupAccess = find(userAccess.groups, ['id', group.id]);
        if (groupAccess && groupAccess.features && find(groupAccess.features, ['id', 11])) { // id=11 for Voice Calls
          showVoiceCallsLink = true;
        }
      }
    }

    return (
      <>
        <div className="row px-2">
          <div className="col-md-12 mt-2">
            <div className="float-left">
              {pathRoot !== "sites" &&
                <Tooltip
                  description={t("manage_notifications.tooltip_description")}
                  placement="bottom"
                >
                  <Button
                    size="sm"
                    onClick={() => {
                      // Set view to notifications
                      this.setState({
                        view: "notifications",
                      });
                    }}
                  >
                    <Icon className="fas fa-bell" />
                  </Button>
                </Tooltip>
              }
              {pathRoot !== "sites" &&
                <Tooltip
                  description={t("manage_integrations.tooltip_description")}
                  placement="bottom"
                >
                  <Button
                    className="ml-2"
                    size="sm"
                    onClick={() => {
                      // Set view to integrations
                      this.setState({
                        view: "integrations",
                      });
                    }}
                  >
                    <Icon className="fas fa-video" />
                  </Button>
                </Tooltip>
              }
              <Tooltip
                description={t("mode_view.tooltip_description")}
                placement="bottom"
              >
                <Button
                  className="ml-2"
                  size="sm"
                  onClick={() => {
                    // Set view to modes
                    this.setState({
                      view: "modes"
                    })
                  }}
                >
                  <Icon className="fas fa-wrench" />
                </Button>
              </Tooltip>
              {showVoiceCallsLink &&
                <Tooltip
                  description={t("voice_calls.tooltip_description")}
                  placement="bottom"
                >
                  <Button
                    className="ml-2"
                    size="sm"
                    onClick={() => {
                      // Set view to phone
                      this.setState({
                        view: "phone"
                      })
                    }}
                  >
                    <Icon className="fas fa-phone" />
                  </Button>
                </Tooltip>
              }
              {(pathRoot === "sites" || (enterprise && enterprise.single_sites)) &&
                <Tooltip
                  description={t("schedules.tooltip_description")}
                  placement="bottom"
                >
                  <Button
                    size="sm"
                    className="ml-2"
                    onClick={() => {
                      // Set view to schedules
                      this.setState({
                        view: "schedules",
                      });
                    }}
                  >
                    <Icon className="fas fa-clock" />
                  </Button>
                </Tooltip>
              }
              {
                (
                  pathRoot === "sites"
                  || (
                    enterprise
                    && enterprise.single_sites
                    && (
                      userAccess
                      && (
                        (userAccess.enterprise && (userAccess.enterprise.role_name === "Admin" || userAccess.enterprise.role_name === "Manager"))
                        || (userAccess.groups && (groupAccess && (groupAccess.role_name === "Admin" || groupAccess.role_name === "Manager")))
                      )
                    )
                  )
                )
                &&
                  <Tooltip
                    description={t("user_management.tooltip_description")}
                    placement="bottom"
                  >
                    <Button
                      className="ml-2"
                      size="sm"
                      onClick={() => {
                        // Set view to usermanagement
                        this.setState({
                          view: "usermanagement"
                        })
                      }}
                    >
                      <Icon className="fas fa-user-plus" />
                    </Button>
                  </Tooltip>
              }
              {
                (enterprise && enterprise.in_alarm && (enterprise.in_alarm === "S" || enterprise.in_alarm === "C" || enterprise.in_alarm === "M")) &&
                  <Tooltip
                      description={t("site_notes.tooltip_description")}
                      placement="bottom"
                    >
                      <Button
                        className="ml-2"
                        size="sm"
                        onClick={() => {
                          // Set view to site notes
                          this.setState({
                            view: "sitenotes"
                          })
                        }}
                      >
                        <Icon className="fas fa-note-sticky" />
                      </Button>
                    </Tooltip>
              }
              {(user.environment === "india") &&
                <Tooltip
                  description={t("alarm_manager.tooltip_description")}
                  placement="bottom"
                >
                  <Button
                    className="ml-2"
                    size="sm"
                    onClick={() => {
                      window.open(
                        'https://www.zipalerts.io/'+String(site.site_ref || site.wwoId),
                        '_blank',
                        'noopener,noreferrer'
                      );
                    }}
                  >
                    <Icon className="fas fa-cogs" />
                  </Button>
                </Tooltip>
              }
              {(user.environment === "india") &&
                <Tooltip
                  description={t("work_order.tooltip_description")}
                  placement="bottom"
                >
                  <Button
                    className="ml-2"
                    size="sm"
                    onClick={() => {
                      window.open(
                        'https://lmsonl.elocks.in/'+String(site.site_ref || site.wwoId),
                        '_blank',
                        'noopener,noreferrer'
                      );
                    }}
                  >
                    <Icon className="fas fa-key" />
                  </Button>
                </Tooltip>
              }
            </div>
            <SelectTimeframe
              className="float-right"
              timeframe={site.timeframe}
              changeTimeframe={origin === "SingleSite"
                ? (timeframe) => {
                    dispatch(changeSingleSitesTimeframe({ timeframe }));
                  }
                : (timeframe) => {
                    dispatch(changeGroupTimeframe({ timeframe }));
                  }
              }
            />
          </div>
        </div>
        <div className="row px-2">
          <LatestAlarm
            site={site}
            newSiteIntegrationsLoading
            viewOpenClose={() => {
              this.setState({
                view: 'openclose'
              });
            }}
          />
        </div>
        <div className="row px-2 mb-2">
          {site.integrations.data.length > 0 && !newSiteLoading && !newSiteIntegrationsLoading && (
            <CameraList integrations={site.integrations.data} />
          )}
        </div>
        <div className="row px-2">
          <div className="col-md-12">{Tabs}</div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state, props) => {
  return {
    enterprise: getEnterpriseFromRoute(state, props),
    userAccess: state.user.access,
    user: state.user,
    // router: {
    //   params: getRouterParams(state, props),
    // },
    group: getGroupFromRoute(state, props) || {
      id: "root",
    },
    pathRoot: getPathRootFromRoute(state),
  };
};
export default withT(
  connect(mapStateToProps)(SiteOverview),
  "site_overview.side_pane"
);
